import type { AudioHTMLAttributes, DetailedHTMLProps } from 'react';
import { useEffect } from 'react';
import { useAudioPlayerRef, useAudioPlayerState } from '@trinity/chat-components/containers/AudioPlayer/Context';
import {
  useAudioPlayerScan, useBootstrapAudioPlayer, useToggleAudioPlaying,
} from '@trinity/chat-components/containers/AudioPlayer/hooks';
import { cx } from '@trinity/chat-components/utils';
import Button from './Button';
import { useKeyboardShortcuts } from './hooks/useKeyboardShortcuts';
import Time from './Progress.Time';
import Track from './Progress.Track';
import styles from './style/Player.module.css';

type Props = {
  className?: string;
  audio: DetailedHTMLProps<AudioHTMLAttributes<HTMLAudioElement>, HTMLAudioElement>;
  onPlay?: () => void;
};

export const AudioPlayer = ({
  audio,
  className,
  onPlay,
}: Props) => {

  const [ref, setPlayerRef] = useAudioPlayerRef();
  const [{ duration, playing }] = useAudioPlayerState();

  const togglePlaying = useToggleAudioPlaying();
  const { scan, seek, position } = useAudioPlayerScan();
  const bootstrapAudioPlayer = useBootstrapAudioPlayer();

  useKeyboardShortcuts();

  useEffect(() => {
    if (ref && onPlay) {
      ref.addEventListener('play', onPlay);
    }

    return () => {
      if (ref && onPlay) {
        ref.removeEventListener('play', onPlay);
      }
    };
  }, [
    ref,
    onPlay,
  ]);


  return (
    <>
      <div className={cx(styles.root, className)}>
        <Button
          playing={playing}
          togglePlaying={togglePlaying} />
        <Track
          position={position}
          scan={scan}
          seek={seek} />
        <Time
          className={styles.time}
          currentTime={position}
          duration={duration} />
      </div>
      <audio
        ref={setPlayerRef}
        {...bootstrapAudioPlayer()}
        {...audio} />
    </>
  );
};